// source: pbtypes/gen/user_camera/skills_photo_metadata.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.user_camera.SkillsPhotoMetadata', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.user_camera.SkillsPhotoMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.user_camera.SkillsPhotoMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.user_camera.SkillsPhotoMetadata.displayName = 'proto.user_camera.SkillsPhotoMetadata';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.user_camera.SkillsPhotoMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.user_camera.SkillsPhotoMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.user_camera.SkillsPhotoMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.user_camera.SkillsPhotoMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
missionExecutionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
actionResultId: jspb.Message.getFieldWithDefault(msg, 2, ""),
capturePointName: jspb.Message.getFieldWithDefault(msg, 3, ""),
structureName: jspb.Message.getFieldWithDefault(msg, 4, ""),
structureId: jspb.Message.getFieldWithDefault(msg, 5, ""),
assetId: jspb.Message.getFieldWithDefault(msg, 7, ""),
assetCustomerId: jspb.Message.getFieldWithDefault(msg, 8, ""),
capturePointId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.user_camera.SkillsPhotoMetadata}
 */
proto.user_camera.SkillsPhotoMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.user_camera.SkillsPhotoMetadata;
  return proto.user_camera.SkillsPhotoMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.user_camera.SkillsPhotoMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.user_camera.SkillsPhotoMetadata}
 */
proto.user_camera.SkillsPhotoMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMissionExecutionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setActionResultId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCapturePointName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStructureName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStructureId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAssetId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAssetCustomerId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCapturePointId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.user_camera.SkillsPhotoMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.user_camera.SkillsPhotoMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.user_camera.SkillsPhotoMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.user_camera.SkillsPhotoMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMissionExecutionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActionResultId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCapturePointName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStructureName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStructureId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAssetId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAssetCustomerId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCapturePointId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string mission_execution_id = 1;
 * @return {string}
 */
proto.user_camera.SkillsPhotoMetadata.prototype.getMissionExecutionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.user_camera.SkillsPhotoMetadata} returns this
 */
proto.user_camera.SkillsPhotoMetadata.prototype.setMissionExecutionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string action_result_id = 2;
 * @return {string}
 */
proto.user_camera.SkillsPhotoMetadata.prototype.getActionResultId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.user_camera.SkillsPhotoMetadata} returns this
 */
proto.user_camera.SkillsPhotoMetadata.prototype.setActionResultId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string capture_point_name = 3;
 * @return {string}
 */
proto.user_camera.SkillsPhotoMetadata.prototype.getCapturePointName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.user_camera.SkillsPhotoMetadata} returns this
 */
proto.user_camera.SkillsPhotoMetadata.prototype.setCapturePointName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string structure_name = 4;
 * @return {string}
 */
proto.user_camera.SkillsPhotoMetadata.prototype.getStructureName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.user_camera.SkillsPhotoMetadata} returns this
 */
proto.user_camera.SkillsPhotoMetadata.prototype.setStructureName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string structure_id = 5;
 * @return {string}
 */
proto.user_camera.SkillsPhotoMetadata.prototype.getStructureId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.user_camera.SkillsPhotoMetadata} returns this
 */
proto.user_camera.SkillsPhotoMetadata.prototype.setStructureId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string asset_id = 7;
 * @return {string}
 */
proto.user_camera.SkillsPhotoMetadata.prototype.getAssetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.user_camera.SkillsPhotoMetadata} returns this
 */
proto.user_camera.SkillsPhotoMetadata.prototype.setAssetId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string asset_customer_id = 8;
 * @return {string}
 */
proto.user_camera.SkillsPhotoMetadata.prototype.getAssetCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.user_camera.SkillsPhotoMetadata} returns this
 */
proto.user_camera.SkillsPhotoMetadata.prototype.setAssetCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string capture_point_id = 6;
 * @return {string}
 */
proto.user_camera.SkillsPhotoMetadata.prototype.getCapturePointId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.user_camera.SkillsPhotoMetadata} returns this
 */
proto.user_camera.SkillsPhotoMetadata.prototype.setCapturePointId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


goog.object.extend(exports, proto.user_camera);
